import React from 'react'
import PasswordChangePopup from './../../Components/PopupMessage/PassordChangePopup/PasswordChangePopup';

const PasswordChangePopupPage = () => {
  return (
    <div>
      <PasswordChangePopup text="Are you sure you want to Change your Password?" />
    </div>
  );
}

export default PasswordChangePopupPage